export default __webpack_public_path__ + "static/media/Arrow.d0fadf9d.svg";